interface EpisodeListProps {
  episodes: number;
  current: number;
  onSelect: (episode: number) => void;
}

export default function EpisodeList({ episodes, current, onSelect }: EpisodeListProps) {
  const list = Array.from({ length: episodes }, (_, i) => i + 1);

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
          <i className="ri-list-check-2 text-primary-500" />
          剧集列表
        </h3>
        <span className="text-sm text-foreground-500">共 {episodes} 集</span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar lg:grid lg:grid-cols-8 lg:overflow-visible xl:grid-cols-10">
        {list.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onSelect(ep)}
            className={`flex h-11 w-16 shrink-0 items-center justify-center rounded-md text-sm font-medium transition-colors ${
              current === ep
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
            }`}
          >
            {ep}
          </button>
        ))}
      </div>
    </div>
  );
}